import axios from "axios";
import { setCreators, setRecommendations } from "../Data/dataStore";
const dyrectApi = process.env.REACT_APP_DYRECT_API_URL;

export const getShows = async (name = '', page = 1, limit = 8) => {
    try {
        const path = "shows/list";
        // Add page and limit to the query parameters
        const response = await axios.get(dyrectApi + path + `?UserID=${localStorage.getItem('user_id')}&ShowName=${name}&page=${page}&limit=${limit}`);
        return response;
    } catch (error) {
        console.error("Error fetching shows:", error);
        return 'Unable to fetch scheduled podcasts';
    }
};


export const getShowDetails = async (ShowID) => {
    try {
        const path = "shows/details";
        const response = await axios.get(dyrectApi + path + `?UserID=${localStorage.getItem('user_id')}&ShowID=${ShowID}`);
        return response;
    } catch (error) {
        return 'Unable to fetch scheduled podcasts';
    }
};

export const showDetailsQuick = async (ShowID) => {
    try {
        const path = "shows/details/quick";
        const response = await axios.get(dyrectApi + path + `?UserID=${localStorage.getItem('user_id')}&ShowID=${ShowID}`);
        console.log('showDetailsQuick response:', response);
        return response;
    } catch (error) {
        console.error('Error fetching quick show details:', error);
        return 'Unable to fetch quick show details';
    }
};

export const showDetailsMedia = async (ShowID) => {
    try {
        const path = "shows/details/media";
        const response = await axios.get(dyrectApi + path + `?UserID=${localStorage.getItem('user_id')}&ShowID=${ShowID}`);
        console.log('showDetailsMedia response:', response);
        return response;
    } catch (error) {
        console.error('Error fetching media show details:', error);
        return 'Unable to fetch media show details';
    }
};

export const getAudioUploadUrl = async (data) => {
    try {
        const path = "getAudioUploadUrl";
        // Change to POST and send data properly
        const response = await axios.post(dyrectApi + path, data);
        return response.data; // Return response.data to access the actual response
    } catch (error) {
        console.error('Error getting upload URL:', error);
        throw new Error('Unable to fetch upload URL');
    }
};

export const updateAudioUploadStatus = async (audioID, status) => {
  try {
    const response = await axios.post(dyrectApi + 'updateAudioUploadStatus', {
      audioID,
      status
    });
    return response.data;
  } catch (error) {
    console.error('Error updating status:', error);
    throw error;
  }
};

export const trimVideo = async (data) => {
    try {
        const path = "trimVideo";
        const response = await axios.post(dyrectApi + path, data);
        return response;
    } catch (error) {
        return 'Unable to fetch trimmed video presigned url';
    }
};

export const fetchVideoFrames = async (data) => {
    try {
        const path = "fetchVideoFrames";
        const response = await axios.post(dyrectApi + path, data);
        return response;
    } catch (error) {
        return 'Unable to save trimmed video presigned url';
    }
};

export const createShow = async (data) => {
    try {
        const path = "show";
        const response = await axios.post(dyrectApi + path, data);
        return response;
    } catch (error) {
        return 'Unable to fetch scheduled podcasts';
    }
};

export const updateShow = async (data) => {
    try {
        const path = "show";
        const response = await axios.put(dyrectApi + path, data);
        return response;
    } catch (error) {
        return 'Unable to fetch scheduled podcasts';
    }
};

export const updateUserProfile = async (data) => {
    try {
        const path = "users";
        const response = await axios.put(dyrectApi + path, data);
        return response;
    } catch (error) {
        return 'Error occurred during user profile updation';
    }
};
export const handleUserSignup = async (data) => {
    try {
        console.log("Signup data:", data)
        const path = "users";
        const response = await axios.post(dyrectApi + path, data);
        return response;
    } catch (error) {
        console.log('Error while handling user sign up: ', error)
        return 'Error occurred during signup';
    }
};
export const getUserProfileDetails = async (type, value = localStorage.getItem('user_id')) => {
    try {
        const path = "users";
        const response = await axios.get(dyrectApi + path + `?${type}=${value}`);
        return response;
    } catch (error) {
        return 'Error occurred while checking User profile';
    }
};
export const emailValidation = async (data) => {
    try {
        const path = "check/email";
        const response = await axios.get(dyrectApi + path + `?Email=${data}`);
        return response;
    } catch (error) {
        return 'Error occurred while checking User profile';
    }
};
export const emailInvite = async (data) => {
    try {
        const path = "send/invite";
        const response = await axios.post(dyrectApi + path, data);
        return response;
    } catch (error) {
        return 'Error occurred while checking User profile';
    }
};

export const updateShowDetails = async (data) => {
    try {
        const path = "shows/details";
        const response = await axios.put(dyrectApi + path, data);
        return response;
    } catch (error) {
        return 'Error occurred while checking User profile';
    }
}

export const deleteShow = async (ShowID) => {
    try {
        const path = `podcasts/recorded?ShowID=${ShowID}`;
        const response = await axios.delete(dyrectApi + path);
        return response;
    } catch (error) {
        return 'Error occurred while checking User profile';
    }
}

export const information = async (data) => {
    try {
        const path = `users`;
        const response = await axios.put(dyrectApi + path, data);
        return response;
    } catch (error) {
        return 'Error occurred while checking User profile';
    }
}

export const getTopCreators = async (StartTime, EndTime) => {
    try {
        let path = "top-creators";
        path += localStorage.getItem('user_id') ? `?UserID=${localStorage.getItem('user_id')}` : '';
        path += StartTime ? `&StartTime=${StartTime}` : '';
        path += EndTime ? `&EndTime=${EndTime}` : '';
        const response = await axios.get(dyrectApi + path);
        setCreators(response?.data?.body.Data);
        return response;
    } catch (error) {
        return 'Unable to fetch top-creators podcasts';
    }
};

export const updateConnects = async (data) => {
    try {
        let path = "connections";
        const response = await axios.post(dyrectApi + path, data);
        return response;
    } catch (error) {
        return 'Unable to fetch connections podcasts';
    }
};

export const getRecommendations = async (page, limit) => {
    try {
        let path = "user-recommendation";
        path += localStorage.getItem('user_id') ? `?UserID=${localStorage.getItem('user_id')}` : '';
        path += page ? `&page=${page}` : '';
        path += limit ? `&limit=${limit}` : '';
        const response = await axios.get(dyrectApi + path);
        setRecommendations(response?.data?.body?.Data || [])
        return response;
    } catch (error) {
        return 'Unable to fetch user-recommendation podcasts';
    }
};

export const skipUser = async (data) => {
    try {
        let path = "skip-user-recommendation";
        const response = await axios.post(dyrectApi + path, data);
        return response;
    } catch (error) {
        return 'Unable to skip user';
    }
};

export const getSearchCreators = async (type, value, page, limit) => {
    try {
        let path = "top-creators";
        path += localStorage.getItem('user_id') ? `?UserID=${localStorage.getItem('user_id')}` : '';
        path += type ? `&filterType=${type}` : '';
        path += value ? `&filterValue=${value}` : '';
        path += value ? `&page=${page}` : '';
        path += value ? `&limit=${limit}` : '';
        const response = await axios.get(dyrectApi + path);
        return response;
    } catch (error) {
        return 'Unable to fetch search result';
    }
};


export const getUserProfile = async (RequestedUserID) => {

    try {
        console.log("myid", localStorage.getItem('user_id'))
        let path = "search-user-profile";
        path += localStorage.getItem('user_id') ? `?UserID=${localStorage.getItem('user_id')}` : '';
        path += RequestedUserID ? `&RequestedUserID=${RequestedUserID}` : '';
        const response = await axios.get(dyrectApi + path);
        return response;
    } catch (error) {
        return 'Unable to fetch user profile result';
    }
};

export const updateStarUser = async (data) => {
    try {
        let path = "starred";
        const response = await axios.put(dyrectApi + path, data);
        return response;
    } catch (error) {
        return 'Unable to star the user';
    }
};

export const unfollowUser = async () => {
    try {
        const path = "unfollow";
        const data = {
            UserID1: localStorage.getItem('user_id'), // User who unfollows
            UserID2: localStorage.getItem('target_user_id') // User being unfollowed
        };
        const response = await axios.post(dyrectApi + path, data);
        return response;
    } catch (error) {
        console.error('Unfollow user error:', error);
        throw new Error('Unable to unfollow the user');
    }
};

export const blockUser = async () => {
    try {
        const path = "block";
        const data = {
            UserId: localStorage.getItem('user_id'), // User who blocks
            BlockedUserId: localStorage.getItem('target_user_id') // User being blocked
        };
        const response = await axios.post(dyrectApi + path, data);
        return response;
    } catch (error) {
        console.error('Block user error:', error);
        throw new Error('Unable to block the user');
    }
};

export const reportUser = async (reason) => {
    try {
        const path = "report";
        const data = {
            UserId: localStorage.getItem('user_id'), // User who reports
            ReportedUserId: localStorage.getItem('target_user_id'), // User being reported
            Reason: reason // Reason for reporting
        };
        const response = await axios.post(dyrectApi + path, data);
        return response;
    } catch (error) {
        console.error('Report user error:', error);
        throw new Error('Unable to report the user');
    }
};
